import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { BarcodeScannerLivestreamComponent } from 'ngx-barcode-scanner';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';


@Component({
	selector: 'app-single-bin-scan',
	templateUrl: './single-bin-scan.component.html',
	styleUrls: ['./single-bin-scan.component.scss']
})
export class SingleBinScanComponent implements OnInit, OnChanges, OnDestroy{
    @Input() viewing_item: any = false;
    @Input() bins: any = false;
	@Input() window_active: any = false;
    @Output() reload_lookup: any = new EventEmitter<any>()

    startbin = new UntypedFormControl('');
    item = new UntypedFormControl('');
    itemcount = new UntypedFormControl(0);
    endbin = new UntypedFormControl('');
    confirmitem = new UntypedFormControl('');

    confirmable: Boolean = false;
    amountToMove: any = 0;
    confirmedMoveAmount: Boolean = false;
    editingCount: Boolean = false;
    currentStep: any = 1;

    frombin: any = false;


    //todo get current user and set default location
    // -bins are stored by loc


    #scanner
    scannerstatus: any = 'Waiting for bin scan...'
    selectedBin: any = false;
    // Core properties
    currentItem: any = null;
    scanMode: 'single' | 'bulk' = 'single';
    bulkQuantity = 0; // Quantity to record for bulk mode
    bulkQuantityInput = 0; // Input field for quantity
    isScanning = false;
    lastScanTime = 0;
    private timeUpdateInterval: any;
    lastSearchTerm: any = '';
    // Essential properties from warehouse-scaninout
    CHAT_ROOM = 'OrderBoard';
    qtyBin: UntypedFormControl = new UntypedFormControl({ value: 'RECDOC', disabled: true }, Validators.required);

    // Scan detail modal properties
    showScanDetailModal = false;
    selectedScanDetail: any = null;

    // Form controls
    scanForm: UntypedFormGroup;
    hiddenScanControl: UntypedFormControl = new UntypedFormControl('');
    qtyRec: UntypedFormControl = new UntypedFormControl(0, Validators.required);

    // Visual feedback
    scanStatus: 'idle' | 'success' | 'error' | 'warning' | 'processing' = 'idle';
    statusMessage = '';
    binLocation = '';


    // Barcode scanner
    useCameraScanner = false;


    // Search functionality
    searchInput = new UntypedFormControl('');
    searchResults: any[] = [];
    isSearchMode = false;
    showSearchResults = false;
    isMobile = false;


    // Keyboard listener control
    keyboardListenerEnabled = true;

    // Warehouse properties (from warehouse-scaninout)
    receiving_quantity = 0;
    receiving_bin = 'RECDOC';
    expected: any = false;
    already_scanned: any = 0;
    scan_history: any = false;
    private hadScansBeforeRefresh = false;
    token: any = false;


    // Core receiving functionality

    qtyAdded = false;
    showScanHistory = false;

    // Vendor management
    selectedVendor: any = null; // No default vendor - user must select
    availableVendors: any[] = [];
    showVendorButtons = false;

	

    // Item details for warehouse-scaninout component
    itemDetailsForScaninout: any = null;

    // MST support (handled by warehouse-scaninout component)
    mstdetails: any = null;

    // UI state
    showDetails = false; // Hidden by default
    undoingLast = false;
    // Feature flags / UI toggles
    showResetControls = false; // Hidden: reset will be triggered via payload later

    // Purchase history (from warehouse-scaninout)
    history: any = false;
    historyloading = false;

    // Enhanced scan capture
    public keyBuffer = '';
    private readonly MIN_BARCODE_LENGTH = 4; // Minimum barcode length
    private readonly MAX_BARCODE_LENGTH = 50; // Maximum barcode length

    // Memory leak prevention - subscription tracking
    private subscriptions: Subscription[] = [];
    private timeouts: any[] = [];
    private intervals: any[] = [];
    private resizeListener: (() => void) | null = null;

    // Socket connection status
    socketConnected = false;
    socketStatusMessage = 'Connecting...';

    autosave = false;
    lastbinupdate: any = false;


	@ViewChild('trigger', { read: MatAutocompleteTrigger }) autocompleteTrigger: MatAutocompleteTrigger; 
    @ViewChild('hiddenScanInput') hiddenScanInput: ElementRef;
	@ViewChild('barcodeScanner') barcodeScanner: BarcodeScannerLivestreamComponent;

	constructor(private globalSearchService: GlobalSearchService, private cdr: ChangeDetectorRef, private inventoryService: InventoryService){

	}


	ngOnDestroy(): void {

	}
    

	ngOnChanges(changes: SimpleChanges): void {
		if(changes.viewing_item){
			if(this.viewing_item.currentValue){
				// this.notificationHandler('information', 'item loaded')
			}
		}

		if(changes.window_active){
			if(changes.window_active.currentValue === 'singlebinscan'){
				setTimeout(() => {
					this.keyboardListenerEnabled = true;
					// Force readonly on hidden input to prevent keyboard
					if (this.hiddenScanInput) {
						this.hiddenScanInput.nativeElement.setAttribute('readonly', 'readonly');
						this.hiddenScanInput.nativeElement.setAttribute('inputmode', 'none');
					}
					// Focus scanner input after view init to prepare for scanning
					setTimeout(() => {
						this.focusScannerInput();
					}, 100);

				}, 350)
			}else{
				this.keyboardListenerEnabled = false;
			}
		}
	}


	ngOnInit(): void {
		this.inventoryService.getVerifiedBinListing().subscribe((res: any) => {
			this.bins = res;
		})

		this.item.disable();
		this.endbin.disable();
		this.confirmitem.disable();

	}



	reset(){
		this.startbin.setValue('');
		this.item.setValue('');
		this.endbin.setValue('');
		this.confirmitem.setValue('');
		

		this.item.disable();
		this.endbin.disable();
		this.confirmitem.disable();

		this.confirmable = false;
		this.confirmedMoveAmount = false;
		this.amountToMove = 0;
		this.currentStep = 1;
		this.frombin = false;
		this.scannerstatus = 'Waiting for bin scan...';
		this.scanStatus = 'idle';
	}


	confirm(){
		const data = {
			'startbin': this.startbin.getRawValue(),
			'item': this.item.getRawValue(),
			'movecount': this.itemcount.getRawValue(),
			'endbin': this.endbin.getRawValue(),
			'confirmitem': this.confirmitem.getRawValue()
		}

		if(Object.values(data).filter(Boolean).length == 5){
			const items = [{
				'stockid': this.viewing_item.item.stockid,
				'lineid': this.viewing_item.item.lineid,
				'bin':data.startbin,
				'description':this.viewing_item.item.description,
				'moveQty': data.movecount,
				'price':this.viewing_item.item.price,
				'qoh':'',
				'supplierno':'',
			}];

			const to_bin = data.endbin;

			this.inventoryService.moveItemsToBin(items, to_bin).subscribe((results: any) => {	
				this.emitChange()
				this.notificationHandler('success', 'Item moved')
				this.reset();
			});
		}else{
			this.notificationHandler('danger', 'Item cound not be moved.')
		}        
	}


	emitChange(){
		this.reload_lookup.emit();
	}



	binExists(bins, input){
		return bins.find((bin) => 
			bin.bin?.toLowerCase() == input.toLowerCase() ||
			bin.location?.toLowerCase() == input.toLowerCase()
		) ?? false;
	}


	hasBarcodeMatch(barcodes, search) {
		let match = [];
		if (barcodes.length) {
			match = barcodes.filter((i) => {

				let hasmatch = false;
				switch (true) {
				case i.toUpperCase() === search.toUpperCase():
					hasmatch = true;
					break;
				case i.slice(-12).toUpperCase() === search.slice(-12).toUpperCase():
					hasmatch = true;
					break;
				case i.slice(0, 12).toUpperCase() === search.slice(0, 12).toUpperCase():
					hasmatch = true;
					break;
				}
				if (hasmatch) {
					return i;
				}
			});
		}
		return match.length ? match[0] : false;
	}



	private processScanInput(barcode: string): void {
		if (!barcode || barcode.trim() === '') {return;}

		const trimmed = barcode.trim();
		if (trimmed.length < 1 || trimmed.length > 100) {
			this.clearScanBuffer();
			return;
		}
		// Update last scan time
		this.lastScanTime = Date.now();
		this.startTimeUpdateInterval();

		this.isScanning = true;
		this.scanStatus = 'processing';
		this.statusMessage = 'Processing scan...';

		const input: any = barcode.trim();
		if(!this.startbin.value){
			this.validation('startbin', input);
			return;
		}

		if(!this.item.value){
			this.validation('item', input);
			return;
		}

		if(!this.confirmedMoveAmount){
			this.validation('itemcount', input);
			return;
		}

		if(!this.endbin.value){
			this.validation('endbin', input);
			return;
		}

		if(!this.confirmitem.value){
			this.validation('confirmitem', input);
			return;	
		}

		
	}

	confirmAmount(){
		let counted = this.itemcount.getRawValue();
		if(isNaN(counted) || counted == 0 || counted > this.frombin.quantity){
			this.notificationHandler('warning', `Movement amount has to be greater than zero`)
			this.clearScanBuffer();
			return
		};

		this.confirmedMoveAmount = true;
		this.endbin.enable();
		this.currentStep = 3;
		this.scannerstatus = "Waiting for end bin scan...";
	}

	//break out into sep functions?
	validation(type: string, input: 'string'){
		const loc = '01';
		if(!input.length){return}
		switch(type){
		case 'startbin':
			const exists = this.binExists(this.viewing_item.bins[loc] ?? [], input);				
			if(exists){
				this.frombin = exists;
				this.startbin.setValue(exists.bin);
				this.scannerstatus = 'Waiting for item scan...'
				this.scanStatus = 'idle';
				this.item.enable();
				this.currentStep = 2;
				//play audio -> mark good -> focus next
			}else{
				this.notificationHandler('danger', 'Item does not exist under this bin')
				this.scanStatus = 'warning';
				setTimeout(()=>{
					this.scanStatus = 'idle';
				}, 3000)
				this.startbin.setValue('');
			}

			break;
			//---------------------------------------------------------------------------------------------------
		case 'item':
			const rightitem = this.hasBarcodeMatch(this.viewing_item.item.upcs ?? [], input);
			if(rightitem){
				this.amountToMove = 1;
				this.itemcount.setValue(this.amountToMove);
				this.item.setValue('Moving...');
				this.scannerstatus = 'Scan item to up qty...'
				this.scanStatus = 'idle';
			}else{
				this.notificationHandler('danger', 'Barcode scanned does not exist under this item')
				this.scanStatus = 'warning';
				setTimeout(()=>{
					this.scanStatus = 'idle';
				}, 3000)
				this.item.setValue('');
			}
			break;
			//---------------------------------------------------------------------------------------------------
		case 'itemcount':
			const sameitem = this.hasBarcodeMatch(this.viewing_item.item.upcs ?? [], input);
			if(sameitem){
				if(this.amountToMove < this.frombin.quantity){
					this.amountToMove += 1;
					this.itemcount.setValue(this.amountToMove);
					
				}else{
					this.notificationHandler('warning', 'Not allowed to move more than remaining in bin.')
				}
			}else{
				this.notificationHandler('danger', 'Barcode does not match selected item.')
			}
			this.scanStatus = 'idle';
			break;
			//---------------------------------------------------------------------------------------------------
		case 'endbin':
			//check if final bin exists and is approved bin
			const binexists = this.binExists(this.bins, input);

				
			if(binexists && this.frombin.bin != binexists.bin){
				this.currentStep = 4;
				this.endbin.setValue(binexists.location ?? binexists.bin);
				this.scannerstatus = 'Final item scan...'
				this.scanStatus = 'idle';
				this.confirmitem.enable();
			}else{
				let msg;
				if(this.frombin.bin != binexists.bin){
					msg = 'Ending bin '+input+' is not a valid bin';
				}else{
					msg = 'Ending bin can not be the same as the original';
				}
				this.notificationHandler('danger', msg)
				this.scanStatus = 'warning';
				setTimeout(()=>{
					this.scanStatus = 'idle';
				}, 3000)
				this.endbin.setValue('');
			}
			break;
			//---------------------------------------------------------------------------------------------------
		case 'confirmitem':
			const confirmed = this.hasBarcodeMatch(this.viewing_item.item.upcs ?? [], input);
			if(confirmed){
				this.confirmitem.setValue(this.viewing_item.item.stockid);
				this.scannerstatus = 'Click confirm below';
				this.scanStatus = 'idle';
				this.confirmable = true;
				this.currentStep = -1;
			}else{
				this.notificationHandler('danger', 'Barcode scanned does not exist under this item')
				this.scanStatus = 'warning';
				setTimeout(()=>{
					this.scanStatus = 'idle';
				}, 3000)
				this.confirmitem.setValue('');
			}
			break;
		default:
			this.notificationHandler('information', 'Unhandled validation...');
			break;
		}
		this.statusMessage = 'Ready for scan...';
	}

	validateItemCount(){
		let counted = Number(this.itemcount.value);
		if(isNaN(counted)){
			counted = 0;
			this.itemcount.setValue(0);
			this.confirmedMoveAmount = false;
			this.confirmitem.setValue(this.viewing_item.item.stockid);
			this.confirmable = false;
			this.currentStep = 1;
			this.endbin.disable();
			this.amountToMove = 0;
			
			this.scanStatus = 'warning';
			this.notificationHandler('warning', 'Step has been reset item count entered was not valid')
			this.scannerstatus = 'Scan item to up qty'


			setTimeout(()=>{
				this.scanStatus = 'idle';
			}, 3000)
			return;
		}

		
		if(counted > Number(this.frombin.quantity)){
			this.notificationHandler('warning', 'Not allowed to move more than remaining in bin.')
			this.confirmedMoveAmount = false;
			this.amountToMove = this.frombin.quantity;
			this.itemcount.setValue(this.amountToMove);
			this.currentStep = 2;
			this.confirmAmount();
		}
	}


	allowedits(){
		this.keyboardListenerEnabled = !this.keyboardListenerEnabled;
		if(!this.keyboardListenerEnabled){
			setTimeout(() => { document.getElementById('itemCountRef').focus(); },150)
			this.editingCount = true;
			this.endbin.disable();
			this.confirmitem.disable()
			this.confirmable = false;
		}else{
			this.editingCount = false;
			this.endbin.enable();

			this.validateItemCount()

			if(this.endbin.getRawValue().length){
				this.confirmitem.enable();
			}

			if(this.confirmitem.getRawValue().length){
				this.confirmable = true;
			}
		}
	}

	

	notificationHandler(type: string, message: string){
		if(['success','warning','danger','information'].includes(type.toLowerCase())){
			this.globalSearchService.showNotification(message, type, 'top', 'right');
		}
	}


	test(){
		console.log(this.viewing_item);
	}































	//scanner functions

	onHiddenInputFocus(): void {
		// Immediately blur to prevent keyboard popup
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.blur();
		}
	}


	onHiddenInputKeyDown(event: KeyboardEvent): void {
		// Only handle Enter key, let other keys pass through to document listener
		if (event.key === 'Enter') {
			event.preventDefault();
			// Use the keyBuffer instead of the form control value to avoid conflicts
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}
	}



	ngAfterViewInit(): void {
		// Force readonly on hidden input to prevent keyboard
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.setAttribute('readonly', 'readonly');
			this.hiddenScanInput.nativeElement.setAttribute('inputmode', 'none');
		}

		// Focus scanner input after view init to prepare for scanning
		setTimeout(() => {
			this.focusScannerInput();
		}, 100);
	}


	private focusScannerInput(): void {
		// Focus on the hidden scan input to prepare for barcode scanning
		if (this.hiddenScanInput) {
			this.hiddenScanInput.nativeElement.focus();
		}
	}

	@HostListener('document:keydown', ['$event'])
	onDocumentKeyDown(event: KeyboardEvent): void {
		const target = event.target as HTMLElement;


		// Allow normal input in search mode for search input fields
		if (this.isSearchMode && (
			target.classList.contains('search-input-field') ||
			target.classList.contains('mat-input-element') ||
			target.tagName === 'INPUT' ||
			target.tagName === 'TEXTAREA'
		)) {
			return; // Don't prevent default behavior for search inputs
		}


		// Skip keyboard listener if disabled
		if (!this.keyboardListenerEnabled) {
			return;
		}

		// Handle barcode scanner input FIRST - build buffer but don't process until Enter
		// Only build buffer in scanner mode, not search mode
		if (event.key.length === 1 && this.isValidScanCharacter(event.key) && !this.isSearchMode) {
			this.keyBuffer += event.key;
			this.isScanning = true;
			// Prevent default behavior to avoid keyboard popup
			event.preventDefault();
			return; // Don't process yet, just build buffer
		}

		// Handle Enter key - process complete barcode (barcode scanner completion)
		// Only process in scanner mode, not search mode
		if (event.key === 'Enter' && !this.isSearchMode) {
			event.preventDefault();
			if (this.keyBuffer.trim()) {
				this.processScanInput(this.keyBuffer.trim());
				this.clearScanBuffer();
			}
		}

		// Handle Escape key - clear buffer
		if (event.key === 'Escape') {
			this.clearScanBuffer();
		}
	}

	private isValidScanCharacter(key: string): boolean {
		// Allow alphanumeric characters, common barcode symbols, and special characters
		return /^[a-zA-Z0-9\-_\.\+\*\#\@\$\%\&\=\!\?\(\)\[\]\{\}\|\\\/\:\;\<\>\,\~\`\s]$/.test(key);
	}

	private startTimeUpdateInterval(): void {
		// Clear existing interval
		if (this.timeUpdateInterval) {
			clearInterval(this.timeUpdateInterval);
			// Remove from tracking array
			const index = this.intervals.indexOf(this.timeUpdateInterval);
			if (index > -1) {
				this.intervals.splice(index, 1);
			}
		}

		// Start new interval to update display every second
		this.timeUpdateInterval = setInterval(() => {
			if (this.lastScanTime) {
				// Use setTimeout to defer change detection and avoid ExpressionChangedAfterItHasBeenCheckedError
				const timeoutId = setTimeout(() => {
					this.cdr.detectChanges();
				}, 0);
				this.timeouts.push(timeoutId);
			}
		}, 1000);

		// Track the interval
		this.intervals.push(this.timeUpdateInterval);
	}

	private clearScanBuffer(): void {
		this.keyBuffer = '';
		this.isScanning = false;
	}
}
